import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IService } from '../../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../../services/shipment-price.service';

@Component({
    selector: 'eci-services-tab-group',
    templateUrl: './services-tab-group.component.html',
    styleUrls: ['./services-tab-group.component.scss']
})
export class ServicesTabGroupComponent implements OnInit {
    public service: IService;
    public serviceId: number;
    public selectedTab: number = 0;

    constructor(private route: ActivatedRoute,
                private shipmentPriceSvc: ShipmentPriceService,
    ) {
    }

    ngOnInit(): void {
        this.route.params.subscribe((value) => {
            if (!value.id) {
                return;
            }
            this.serviceId = value.id;
            this.getService(+value.id);
        });
    }

    private getService(id: number): void {
        this.shipmentPriceSvc.getServiceById(id).subscribe((data) => {
            if (!data) {
                return;
            }
            this.service = data;
        });
    }

    public changeTab(): void {
        this.selectedTab = 0;
    }
}
